import { IOBuffer } from 'iobuffer';
import { fileHeader, TheNewHeader } from './fileHeader';
import { readLogBlock } from './logBlock';
import { newDataBlock } from './newDataBlock';
import { oldDataBlock } from './oldDataBlock';
/**
 * Parses an SPC file.
 *
 * @param  buffer SPC file buffer.
 * @return JSON-like object with information contained in the SPC file.
 */
export function parse(buffer) {
    const ioBuffer = new IOBuffer(buffer);
    const meta = fileHeader(ioBuffer);
    if (meta instanceof TheNewHeader) {
        //new format
        const spectra = newDataBlock(ioBuffer, meta);
        const logs = meta.logOffset !== 0 ? readLogBlock(ioBuffer, meta.logOffset) : null;
        return { meta, spectra, logs };
    }
    else {
        //old format
        return {
            meta,
            spectra: oldDataBlock(ioBuffer, meta),
        };
    }
}
//# sourceMappingURL=parse.js.map